export const techs = [
  {
    id: 1,
    title: 'PCO',
    description:
      'Uma aplicação Web criada com a finalidade de permitir os estudantes e encarregados de educação fazerem pagamentos online',
    data: '20-02-2017',
    link: 'https://pco.vercel.app/',
    company: false,
    tech: [
      {
        name: 'Node.js',
      },
      {
        name: 'Express',
      },
      {
        name: 'Mongodb',
      },
      {
        name: 'React',
      },
    ],
  },
  {
    id: 2,
    title: 'Bibioteca Online',
    description:
      'Uma versão mais agradável para acessar qualquer projecto de fim de curso, sendo os melhores destacados em primeiro lugar.',
    data: '20-02-2018',
    link: '',
    company: false,
    tech: [
      {
        name: 'Node.js',
      },
      {
        name: 'React',
      },
      {
        name: 'Redux',
      },
      {
        name: 'styled-components',
      },
    ],
  },
  {
    id: 3,
    title: 'Sistema de G. Escolar',
    description:
      'Um sistema de gestão escolar desktop, criado para ajudar a gerir um pequeno colégio com mais de 1643 alunos.',
    data: '20-10-2018',
    link: '',
    company: false,
    tech: [
      {
        name: '.net',
      },
      {
        name: 'C# (POO)',
      },
      {
        name: 'SQL Server',
      },
      {
        name: 'Windows Form Application',
      },
    ],
  },
  {
    id: 4,
    title: 'Loja do dia',
    description:
      'Delivery de venda de produtos comestíveis. Iniciando apenas como uma sturtap de venda de produtos comestíveis, ao passa do tempo, eu juntamente com a equia passamos para uma loja virtuar mais usada em portugual.',
    data: '20-10-2018',
    link: 'https://www.lojadodia.com/loja',
    company: true,
    tech: [
      {
        name: 'PHP',
      },
      {
        name: 'Nextjs)',
      },
      {
        name: 'Postgresql',
      },
      {
        name: 'Todas as ferramentas no nextjs v12',
      },
    ],
  },
  {
    id: 5,
    title: 'ECASIM',
    description: 'Uma aplicação Web com finalidade de consutória online',
    data: '20-10-2018',
    link: 'https://ecasim.ao/',
    company: true,
    tech: [
      {
        name: 'Reactjs',
      },
      {
        name: 'typescript)',
      },
      {
        name: 'styled-components',
      },
      {
        name: 'Firebase',
      },
    ],
  },
  {
    id: 6,
    title: 'ToquePlay',
    description:
      'ToquePlay é um serviço de streaming e venda de músicas online',
    data: '20-10-2020',
    link: 'https://www.toqueplay.com/',
    company: true,
    tech: [
      {
        name: 'React',
      },
      {
        name: 'typescript)',
      },
      {
        name: 'styled-components',
      },
      {
        name: 'Firebase',
      },
      {
        name: 'AWS3',
      },
    ],
  },
  {
    id: 7,
    title: 'Gddkia',
    description:
      'Sistema de gerenciamento de estradas e Autoestradas na Polónia',
    data: '20-10-2022',
    link: 'https://drogi.gddkia.gov.pl/',
    company: true,
    tech: [
      {
        name: 'Nextjs(12)',
      },
      {
        name: 'typescript)',
      },
      {
        name: 'Material UI',
      },
      {
        name: 'Python (Django)',
      },
      {
        name: 'AWS3',
      },
      {
        name: 'Redux',
      },
      {
        name: 'PostgreSql',
      },
    ],
  },
  {
    id: 8,
    title: 'Urbanização Boa Vida',
    description:
      'Desenvolvedor de todos os projectos web Interno (deste sites e sistemas no departamento de TI)',
    data: '20-10-2023',
    link: 'https://site-gbv.vercel.app/',
    company: true,
    tech: [
      {
        name: 'Nextjs(13)',
      },
      {
        name: 'typescript)',
      },
      {
        name: 'MUI UI',
      },
      {
        name: 'AWS3',
      },
      {
        name: 'Redux',
      },
      {
        name: 'PostgreSql',
      },
    ],
  },
];
